import { createSlice } from "@reduxjs/toolkit";
import { addAndEditStationImageAPI } from "../../actions/stations/addStationImages";

const initialState = {
  stationImage: {},
  loading: false,
  error: { code: "", message: "" },
};

const addStationImageSlice = createSlice({
  name: "addAndEditStationImage",
  initialState,
  reducers: {
    resetUserData: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addAndEditStationImageAPI.pending, (state) => {
        state.loading = true;
      })
      .addCase(addAndEditStationImageAPI.fulfilled, (state, action) => {
        state.stationImage = action.payload.data;
        state.loading = false;
      })
      .addCase(addAndEditStationImageAPI.rejected, (state, action) => {
        state.error = action.payload.error;
        state.loading = false;
      });
  },
});

export default addStationImageSlice.reducer;
